import React, { Component } from 'react';
import {Table} from 'react-bootstrap';
import { Link } from 'react-router-dom';
import moment from 'moment';
import PropTypes from "prop-types";
import { formatSmartDate } from "../../Utils/DateFormatter";


class PanelistTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentPage: 1,
            itemsPerPage: 100
        };
    }

    render() {
        const { sendCurrentPage, sendCurrentPageSize } = this.props;
        const currentItems = this.props.filteredData;      

        return (
            <div>
                <Table responsive size="sm" bordered>
                    <thead>
                    <tr>
                        <th>S.No</th>
                        <th>User Id</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Phone Number</th>
                        <th>State</th>
                        <th>City</th>
                        <th>Date Of Birth</th>
                        <th>Login Reward Type</th>
                        <th>Store ID</th>
                        <th>Created At</th>
                    </tr>
                    </thead>
                    <tbody>
                    {currentItems.map((info, index) => (
                        <tr key={info.id}>
                            <td>{((sendCurrentPageSize)*(sendCurrentPage-1))+(index + 1)}</td>
                            <td>{info.id}</td>
                            <td>
                                <Link
                                    to={`/${this.props.role === 'sub-admin' ? 'sub-admin' : 'admin'}/panelistDetails/${info.id}`}
                                    target="_self"
                                >
                                    {info.firstName ? `${info.firstName} ${info.lastName}` : '-'}
                                </Link>
                            </td>
                            <td>
                                <Link
                                    to={`/${this.props.role === 'sub-admin' ? 'sub-admin' : 'admin'}/panelistDetails/${info.id}`}
                                    target="_self"
                                >
                                    {info.email}
                                </Link>
                            </td>
                            <td>{info.phoneNumber}</td>
                            <td>{info.state ? info.state : '-'}</td>
                            <td>{info.city ? info.city : '-'}</td>
                            <td>{info.dateOfBirth ? formatSmartDate(info.dateOfBirth, false) : 'NA'}</td>
                            <td>{info.loginRewardType ? info.loginRewardType : '-'}</td>
                            <td>{info.loginStoreId ? info.loginStoreId : '-'}</td>
                            <td>{formatSmartDate(info.createdAt)}</td>
                        </tr>
                    ))}
                    </tbody>
                </Table>
            </div>
        );
    }
}

PanelistTable.propTypes = {
    sendCurrentPage: PropTypes.number, 
    sendCurrentPageSize: PropTypes.number,
    filteredData: PropTypes.array,
    role: PropTypes.string,
}

export default PanelistTable;
